// @flow
import * as React from 'react';
import type { Answer, Question } from 'models';
import { ContentSection } from './ContentSection';
import { ClientUgcMetaInfo } from 'components/ContentSection/UgcMetaInfo';
import { Article } from './QAComponents';
import { AnswerArticle } from './AnswerArticle';

type AnswerSectionProps = {
  ugc: Answer,
  canModerate?: boolean,
  children?: ?React.Node,
  MetaInfoComponent: React.ComponentType<{ model: Ugc }>,
  subject: Product,
  locale: string,
  allowMedia: boolean,
};

export class AnswerSection extends React.Component<AnswerSectionProps> {
  static defaultProps = {
    MetaInfoComponent: ClientUgcMetaInfo,
  };

  render() {
    const { ugc, MetaInfoComponent, subject, locale, allowMedia } = this.props;
    const parentUgc: Question = ugc.getQuestion();

    return (
      <ContentSection>
        {parentUgc && (
          <ContentSection.Section>
            <div className="o-40">
              <Article ugc={parentUgc} />
            </div>
          </ContentSection.Section>
        )}
        <ContentSection.Divider />
        <ContentSection.Section>
          <AnswerArticle
            ugc={ugc}
            viewContext="Answer"
            subject={subject}
            locale={locale}
            parentUgcId={parentUgc.ugc_id}
            allowMedia={allowMedia}
          />
        </ContentSection.Section>
        <ContentSection.Meta>
          <MetaInfoComponent model={ugc} />
        </ContentSection.Meta>
      </ContentSection>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ContentSection/__future__/AnswerSection.js